<template>
  <div id="app" >
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',

}
</script>

<style>
  *{
    margin: 0;
    padding: 0;
  }

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  /*width: 100vw;*/
  /*height: 100vh;*/
  min-width: 1300px;
  min-height: 700px;
  /*overflow-x: hidden;*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue